




















import { Component, Vue } from "vue-property-decorator";
import ConstructionTypeTable from "@/components/project/property/ConstructionTypeTable.vue";
import {
  ConstructionType,
  deleteConstructionType,
  getConstructionTypes
} from "@/api/project/construction-types-api";

@Component({
  components: {
    ConstructionTypeTable
  }
})
export default class ProjectPropertyWorkTypes extends Vue {
  constructionTypes: ConstructionType[] | [] = [];

  mounted() {
    this.initConstructionTypes();
  }

  async initConstructionTypes() {
    const data = await getConstructionTypes();
    this.constructionTypes = data;
  }

  async handleDelete(id: string, index: number) {
    if (!confirm("この項目を削除してもよろしいですか？")) return;
    try {
      await deleteConstructionType(id);
      this.constructionTypes.splice(index, 1);
    } catch (error) {
      alert(error);
    }
  }
}
